import * as React from "react"

function ParametereValuesSvg (props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={87.848}
            height={40}
            viewBox="0 0 47.848 37.114"
            {...props}
        >
            <g data-name="Group 1672" fill="#b5b5c3">
                <path
                    data-name="Path 26228"
                    d="M23.926 37.11H3.798a3.485 3.485 0 01-3.666-2.628 5.608 5.608 0 01-.126-1.334q-.008-11.575 0-23.151c0-2.1-.013-4.2 0-6.3a3.5 3.5 0 012.721-3.6 4.626 4.626 0 011.069-.1h40.256a3.47 3.47 0 013.665 2.627 5.607 5.607 0 01.128 1.334q.011 6.972 0 13.943v15.4a3.524 3.524 0 01-2.723 3.709 4.683 4.683 0 01-1.07.1q-10.064.008-20.128 0zM1.096 26.491c.164.011.288.026.411.027h3.184c.361 0 .616.151.624.515s-.249.535-.6.546c-.233.007-.468 0-.7 0H1.063V33.295a2.484 2.484 0 002.773 2.757h40.15a2.5 2.5 0 002.8-2.791v-14.17h-3.64c-.358 0-.611-.171-.609-.536s.254-.533.611-.536H46.742v-8.45H1.096zM1.064 8.439h45.668c0-1.811.062-3.585-.025-5.352a2.107 2.107 0 00-1.665-1.908 4.126 4.126 0 00-1.173-.115q-16.675-.008-33.35 0c-2.285 0-4.569-.014-6.853.008a2.435 2.435 0 00-2.6 2.6c-.008.467 0 .933 0 1.4-.003 1.108-.003 2.216-.003 3.366z"
                />
                <path
                    data-name="Path 26229"
                    d="M23.948 13.792h12.3c.886 0 .961.074.961.943v5.652c0 .679-.141.826-.817.826q-12.462.005-24.925 0c-.679 0-.821-.147-.821-.823v-5.76c0-.738.1-.842.843-.843q6.228.005 12.459.005zm-12.214 6.331h24.367v-5.235H11.734z"
                />
                <path
                    data-name="Path 26230"
                    d="M23.911 31.812h-12.41c-.738 0-.861-.118-.861-.827V25.17c0-.632.156-.787.8-.787h24.983c.615 0 .779.158.78.754v5.923c0 .606-.15.749-.775.749H23.91zm-12.16-6.347v5.238h24.347v-5.238z"
                />
                <path
                    data-name="Path 26231"
                    d="M34.5 5.303h-8.085c-.161 0-.363.042-.474-.036-.168-.12-.377-.328-.377-.5s.205-.388.376-.5c.13-.083.349-.036.528-.037h16.171c.144 0 .326-.051.423.017.2.138.476.341.476.517s-.28.38-.475.518c-.1.068-.279.017-.423.017z"
                />
                <path
                    data-name="Path 26232"
                    d="M10.103 4.751a1.063 1.063 0 11-2.125.032A1.1 1.1 0 019.03 3.704a1.073 1.073 0 011.073 1.047z"
                />
                <path
                    data-name="Path 26233"
                    d="M4.802 3.707a1.062 1.062 0 11-1.065 1.051 1.076 1.076 0 011.065-1.051z"
                />
                <path
                    data-name="Path 26234"
                    d="M12.249 4.748a1.046 1.046 0 111.026 1.082 1.056 1.056 0 01-1.026-1.082z"
                />
                <path
                    data-name="Path 26235"
                    d="M16.98 18.024c-.484 0-.968-.005-1.452 0-.36.005-.612-.152-.628-.512s.235-.554.587-.557q1.533-.013 3.065 0c.353 0 .637.216.557.56a.817.817 0 01-.574.477 11.476 11.476 0 01-1.556.022z"
                />
                <path
                    data-name="Path 26236"
                    d="M24.425 18.022a10.378 10.378 0 01-1.5-.023c-.217-.032-.4-.312-.593-.48.181-.186.354-.524.544-.533a31.286 31.286 0 013.168 0c.186.009.355.352.532.541-.2.166-.379.445-.595.475a11.383 11.383 0 01-1.556.02z"
                />
                <path
                    data-name="Path 26237"
                    d="M17 27.58a11.211 11.211 0 011.554.023c.214.03.392.315.586.484-.185.18-.363.507-.556.516-1.054.05-2.112.046-3.166 0a.743.743 0 01-.5-.492c-.062-.315.184-.524.526-.529.519-.008 1.038 0 1.557 0z"
                />
                <path
                    data-name="Path 26238"
                    d="M24.452 28.639h-1.4c-.385 0-.714-.117-.707-.552.006-.4.314-.514.684-.512q1.4.01 2.807 0c.378 0 .728.071.732.516 0 .482-.371.548-.763.544h-1.349z"
                />
            </g>
        </svg>
    )
}

export default ParametereValuesSvg
